<template>
  <div>
    <center>
      <b-tabs style="background-color: transparent !important">
        <b-tab
          title="Service OKBA"
          style="margin-top: 31px; background-color: transparent !important"
        >
          <div class="container-fluid" style="height: 65px">
            <div class="text-center" style="margin-top: -33px !important">
              <b-button variant="info" style="font-size: 15px">
                Total <b-badge variant="light">{{ count_service }}</b-badge>
              </b-button>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @change="loadServiceOkbaMois(selectedMois.Month)"
                    v-model="selectedMois.Month"
                  >
                    <option value disabled selected>Mois</option>
                    <option
                      v-for="(annUsers, index) in moezMois"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="SelectRegion"
                    required
                    @change="loadServiceOkbaMois(selectedClient.year)"
                    v-model="selectedClient.year"
                  >
                    <option value disabled selected>Année</option>
                    <option
                      v-for="(annUsers, index) in moezAnnee"
                      :value="annUsers.id"
                      :key="'i' + index"
                    >
                      {{ annUsers.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <input
                    class="form-control personalise"
                    placeholder="Recherche ..."
                    type="text"
                    v-model="search"
                  />
                </div>
              </div>
            </div>

            <div class="table-responsive" style="border: 1px solid #f5a623">
              <table class="table table-white">
                <thead>
                  <tr>
                    <!--  <th scope="col">#</th> -->

                    <th scope="col">Matricule</th>

                    <!-- <th scope="col">Chouffeur</th> -->

                    <th scope="col">Date</th>

                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in filteredservices" v-bind:key="user.id">
                    <td>
                      {{ user.matr }}
                    </td>

                    <!-- <td v-text="user.nom_chouffeur"></td> -->

                    <td>{{ user.created_at }}</td>

                    <td>
                      <img
                        src="https://img.icons8.com/fluency/48/000000/delete-bookmark.png"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </center>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import HighlightWords from "vue-highlight-words";

import Highlighter from "vue-highlight-words";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {
    Highlighter,
    HighlightWords,
  },
  data() {
    return {
      search: "",
      listes_service: [],
      selected: [],
      get_societe_id_mise: {},
      verif: false,
      selectedOptionId: "",
      moezMois: [
        { id: 1, text: "Janvier" },
        { id: 2, text: "Février" },

        { id: 3, text: "Mars" },
        { id: 4, text: "Avril" },
        { id: 5, text: "Mai" },
        { id: 6, text: "Juin" },

        { id: 7, text: "Juillet" },
        { id: 8, text: "Août" },

        { id: 9, text: "Septembre" },
        { id: 10, text: "Octobre" },
        { id: 11, text: "Novembre" },
        { id: 12, text: "Décembre" },
      ],
      moezAnnee: [
        { id: 2020, text: "2020" },
        { id: 2021, text: "2021" },
        { id: 2022, text: "2022" },

        { id: 2023, text: "2023" },
        { id: 2024, text: "2024" },
        { id: 2025, text: "2025" },
        { id: 2026, text: "2026" },

        { id: 2027, text: "2027" },
        { id: 2028, text: "2028" },
      ],
      anneeUsers: [2020, 2021, 2022, 2024],
      moisUsers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

      yearSystem: new Date().getFullYear(),
      moisSystem: new Date().getMonth() + 1,
      selectedMois: {
        Month: new Date().getMonth() + 1,
      },

      selectedClient: {
        year: new Date().getFullYear(),
      },
      listes_service: [],
      selected: [],
      q: "",
      /* ******************************* */
      totalTraitementAnnee_v: "",
      service_listes: [],
      count_service: "",
    };
  },

  created() {
    //this.fetchListesTypes();
    this.fetchsearch();
    this.loadServiceOkbaMois();
  },

  computed: {
    filteredservices: function () {
      if (Array.isArray(this.service_listes)) {
        return this.service_listes.filter((pack) => {
          return (
            pack.matr.match(this.search) ||
            pack.nom_chouffeur.match(this.search)
          );
        });
      }
    },
  },

  methods: {
    /* new azouz 2021 */
    keywords() {
      return this.search.split(" ");
    },

    loadServiceOkbaMois() {
      axios
        .get(
          `${apiDomain}/api/get_all_services_okba/${this.selectedMois.Month}/${this.selectedClient.year}`
        )
        .then((response) => {
          this.service_listes = response.data.contacts;
          this.count_service = response.data.count_service;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /* fin new 2022 */
    fetchsearch() {
      if (this.q.length > 1) {
        axios
          .get(`${apiDomain}/api/Listes_services_ajouter/` + this.q)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      } else {
        axios
          .get(`${apiDomain}/api/Listes_services_ajouter`)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      }
    },
    /*  delete_service(id) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: 'delete',
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success('Service  supprimer avec Succès ! ')

          this.fetchsearch()
        })

        .catch((err) => console.log(err))
    }, */
    /*   fetchListesTypes() {
      fetch(`${apiDomain}/api/Listes_services_ajouter`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service.data;
        })
        .catch((err) => console.log(err));
    }, */
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */
</style>

